import filter from "./filterC.js";

export default filter((a) => a);
